"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const providers_1 = require("@mne-core/providers");
const ArgusMenuLogo = ({ href, src, logger }) => {
    const theme = (0, styles_1.useTheme)();
    const staticUrl = (0, providers_1.getStaticUrl)();
    // This check short circuits the component if no link to logo is provided
    if (!href || !src) {
        logger.logError(`Menu without logo. href: ${href}, src: ${src}`);
        return null;
    }
    return (react_1.default.createElement("a", { href: (0, providers_1.toSpaUrl)(href), style: {
            cursor: "pointer",
            marginRight: theme.spacing(1),
        } },
        react_1.default.createElement("img", { src: `${staticUrl}/${src}`, style: {
                minHeight: "32px",
                height: "40px",
                margin: theme.spacing(1.5),
                marginLeft: theme.spacing(3),
            } })));
};
exports.default = ArgusMenuLogo;
